
import _ from '../../utils/underscore';
import BaseService from '../../base/base_service';

/**
 *
 *
 *
 */
class InfiniteScrollService extends BaseService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'InfiniteScrollService';


    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);
    }

    onScroll(onFulfilled) {
        if (_.isFunction(onFulfilled)) {
            this._doOnScroll = onFulfilled;
        }

        return this;
    }

    stop(){
        this._scene.destroy();
    }

    async initScrollMagic(triggerElement) {
        if (!triggerElement) {
            return;
        }
        const ScrollMagic = await import('scrollmagic').then(m => m.default);

        // init controller
        const controller = new ScrollMagic.Controller();

        const sceneOptions = {
            triggerElement: triggerElement,
            triggerHook: "onEnter",
            offset: 0,
            //loglevel: 3
        };

        // build scene
        this._scene = new ScrollMagic.Scene(sceneOptions)
            .addTo(controller)
            .on("enter", e => {
                this.logger.debug('ScrollMagic onEnter', e);

                this._doOnScroll.apply(this);
            });
    }

    updateTriggerElement(el){
        if(el) {
            this._scene.triggerElement(el);
        }

        return this;
    }

}

export default InfiniteScrollService;